import React, { useState } from 'react'
import styles from './PlayerNotifications.module.css'
import classnames from 'classnames'
import useStorage from 'frontend/utils/hooks/useStorage'
import { PARENTAL_LOCK_LOCAL_STORAGE_KEY } from 'components/ParentalLock/ParentalLock'
import SpaLink from 'components/SpaLink/SpaLink'

export interface Notification {
  content: JSX.Element
  onDismiss?: () => void
  isDismissable?: boolean
}
interface PlayerNotificationsProps {
  currentProductParentalLock: boolean
}

const PARENTAL_LOCK_MESSAGE = 'Programmet är olämpligt för barn. '
const PARENTAL_LOCK_URL = '/barnlas'

const ParentalLockMessage = ({ isActive }: { isActive: boolean }) => {
  return (
    <span key={isActive ? 'parental-lock-active' : 'parental-lock-inactive'}>
      <span>{PARENTAL_LOCK_MESSAGE}</span>
      <SpaLink href={PARENTAL_LOCK_URL} className={styles.notificationLink}>
        {isActive ? 'Stäng av barnlåset' : 'Sätt på barnlåset'}
      </SpaLink>
    </span>
  )
}

const PlayerNotifications = ({
  currentProductParentalLock,
}: PlayerNotificationsProps) => {
  const [hasBeenDismissed, setHasBeenDismissed] = useState(false)
  const { storageValue: parentalLockIsEnabled } = useStorage(
    PARENTAL_LOCK_LOCAL_STORAGE_KEY,
  )

  const dismiss = () => {
    setHasBeenDismissed(true)
  }

  if (
    (hasBeenDismissed && currentProductParentalLock) ||
    !currentProductParentalLock
  ) {
    return null
  }

  const activateParentalLockMessage =
    !hasBeenDismissed && currentProductParentalLock && !parentalLockIsEnabled

  const inactivateParentalLockMessage =
    parentalLockIsEnabled && currentProductParentalLock

  return (
    <div
      className={classnames(styles.playerNotifications, {
        [`${styles.activeParentalLock}`]:
          parentalLockIsEnabled && currentProductParentalLock,
      })}
    >
      {activateParentalLockMessage && (
        <div className={styles.notification}>
          <p data-testid="notification">
            <ParentalLockMessage isActive={false} />
          </p>
          <div className={styles.closeContainer}>
            <button
              className={styles.close}
              type="button"
              onClick={() => {
                dismiss()
              }}
              aria-label="Stäng notifiering"
            >
              <span
                data-testid="dismiss-notification-btn"
                className={styles.icon}
              />
            </button>
          </div>
        </div>
      )}
      {inactivateParentalLockMessage && (
        <div className={styles.notification}>
          <p data-testid="notification">
            <ParentalLockMessage isActive />
          </p>
          <div className={styles.closeContainer}></div>
        </div>
      )}
    </div>
  )
}

export default PlayerNotifications
